import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TipoMaterialN1, TIPO_MATERIAL_LABELS, ITipoMaterialPermitido } from "../../types/materiaisN1.types";
import { useNavigate } from "react-router-dom";

interface ModalNovoCadastroProps {
  open: boolean;
  onClose: () => void;
  tiposPermitidos: ITipoMaterialPermitido[];
}

export const ModalNovoCadastro: React.FC<ModalNovoCadastroProps> = ({
  open,
  onClose,
  tiposPermitidos,
}) => {
  const navigate = useNavigate();
  const [tipoSelecionado, setTipoSelecionado] = useState<TipoMaterialN1 | null>(
    tiposPermitidos.find(t => t.podeIncluir)?.tipoMaterial || null
  );

  // Filtrar apenas tipos com permissão de inclusão
  const tiposComPermissao = tiposPermitidos.filter(t => t.podeIncluir);

  const handleSalvar = () => {
    if (!tipoSelecionado) return;

    // Mapear tipo para rota de cadastro
    // Perfis e Componentes usam a nova rota interna, outros tipos usam o sistema antigo
    const rotasCadastro: Record<TipoMaterialN1, { rota: string; interno: boolean }> = {
      perfis: { rota: "/produtosN1/perfis/novo", interno: true },
      componentes: { rota: "/produtosN1/componentes/novo", interno: true },
      vidros: { rota: "/produtosN1/vidros/novo", interno: true },
      superficies: { rota: "/produtosN1/superficies/novo", interno: true },
      kits: { rota: "/produtosN1/kits/novo", interno: true },
      acabamentos: { rota: "/produtosN1/acabamentos/novo", interno: true },
    };

    const config = rotasCadastro[tipoSelecionado];
    if (config) {
      onClose();
      
      if (config.interno) {
        // Usar navigate para rotas internas do React Router
        navigate(config.rota);
      } else {
        // Redirecionar para o sistema antigo
        window.location.href = config.rota;
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "750px",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ color: "#3C90AD", fontWeight: 500, fontSize: "1rem" }}>
            Novo cadastro
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        {tiposComPermissao.length === 0 ? (
          <Typography variant="body2" color="error" sx={{ textAlign: "center", py: 3 }}>
            Você não possui permissão para cadastrar nenhum tipo de produto.
          </Typography>
        ) : (
          <RadioGroup
            row
            value={tipoSelecionado || ""}
            onChange={(e) => setTipoSelecionado(e.target.value as TipoMaterialN1)}
            sx={{ flexWrap: "nowrap" }}
          >
            {tiposComPermissao.map((tipo) => (
              <FormControlLabel
                key={tipo.idTipoMaterial}
                value={tipo.tipoMaterial}
                control={<Radio size="small" sx={{ color: "#3C90AD", "&.Mui-checked": { color: "#3C90AD" } }} />}
                label={
                  <Typography sx={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                    {TIPO_MATERIAL_LABELS[tipo.tipoMaterial]}
                  </Typography>
                }
                sx={{ mr: 2 }}
              />
            ))}
          </RadioGroup>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderColor: "#3C90AD", color: "#3C90AD" }}>
          CANCELAR
        </Button>
        <Button
          onClick={handleSalvar}
          variant="contained"
          disabled={!tipoSelecionado || tiposComPermissao.length === 0}
          sx={{ backgroundColor: "#3C90AD", "&:hover": { backgroundColor: "#2d6f87" } }}
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};
